import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const notifySuccess = (body, options) =>
  toast.success(body, {
    ...defaultOptions,
    ...options,
    delay: 800,
  });

export const notifyWarning = (body, options) =>
  toast.warn(body, {
    ...defaultOptions,
    ...options,
    delay: 300,
  });

export const notifyError = (body, options) =>
  toast.error(body, {
    ...defaultOptions,
    ...options,
    delay: 300,
  });

const defaultOptions = {
  position: toast.POSITION.TOP_RIGHT,
  theme: 'colored',
  autoClose: 4000,
};
